import React, { useState } from "react";
import { Layout } from "antd";
import PatientSidebar from './../../Components/Patient/Sidebar/PatientSidebar';

const { Header, Content } = Layout;

export default function PatientLayout({ title, rightContent, children }) {
    const [collapsed, setCollapsed] = useState(false);

    return (
        <Layout className="min-vh-100 bg-white">
            <PatientSidebar collapsed={collapsed} onCollapse={setCollapsed} />

            <Layout>
                <Header className="bg-white px-4 px-lg-8 border-bottom h-auto py-5">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                        <h1 className="mb-0 fw-bold text-dark">{title}</h1>
                        {rightContent}
                    </div>
                </Header>

                <Content className="p-4 p-lg-8 bg-body-tertiary">
                    {children}
                </Content>
            </Layout>
        </Layout>
    );
}
